import { ppdtOne } from "./ppdtPracticeResponse";
import { ppdtTwo } from "./ppdtPracticeResponse";
import { ppdtThree } from "./ppdtPracticeResponse";
import { ppdtFour } from "./ppdtPracticeResponse";
import { ppdtFive } from "./ppdtPracticeResponse";
import { ppdtSix } from "./ppdtPracticeResponse";
import { ppdtSeven } from "./ppdtPracticeResponse";
import { ppdtEight } from "./ppdtPracticeResponse";
import { ppdtNine } from "./ppdtPracticeResponse";
import { ppdtTen } from "./ppdtPracticeResponse";

export const ppdtResponses = {
  one: ppdtOne,
  two: ppdtTwo,
  three: ppdtThree,
  four: ppdtFour,
  five: ppdtFive,
  six: ppdtSix,
  seven: ppdtSeven,
  eight: ppdtEight,
  nine: ppdtNine,
  ten: ppdtTen,
};
